module.exports = __webpack_public_path__ + "img/pi3ckimage.e6ea3318.png";